//#region src/location_tips_level.ts
var LocationTipsLevel = /* @__PURE__ */ function(LocationTipsLevel) {
	LocationTipsLevel[LocationTipsLevel["Off"] = 0] = "Off";
	LocationTipsLevel[LocationTipsLevel["On"] = 1] = "On";
	LocationTipsLevel[LocationTipsLevel["Forced"] = 2] = "Forced";
	LocationTipsLevel[LocationTipsLevel["PromptAfterPaymentSelected"] = 3] = "PromptAfterPaymentSelected";
	return LocationTipsLevel;
}(LocationTipsLevel || {});
//#endregion
export { LocationTipsLevel };

//# sourceMappingURL=location_tips_level.js.map